module.exports = __webpack_public_path__ + "img/gg.177ff1e4.svg";